function openCloseAccordionInitially() {
    $('.togglePackageDetails').each(function() {
        var slide = 'up';
        if(!$(this).is(':visible') || ($(this).is(':visible') && $(this).hasClass('open'))) {
            slide = 'down';
        }

        if(slide === 'up') {
            $(this).closest('.productboxWrapper').find('.packageDetails').slideUp();
        } else {
            $(this).closest('.productboxWrapper').find('.packageDetails').slideDown(function() {
                resizeIframe();
            });
        }
    });
}

$(function(){
    // GMap Autocomplete
    $('#gMap_autocomplete_confirm').click(function(e) {
        e.preventDefault();
        fillInAutoCompleteAddress();
    });

    if ($('#preConfFormLocationMap').length && ($('#geo_latitude').val() === '' || $('#geo_longitude').val() === '')) {
        $('body.page_preConf2024LocationMap #submitBtnForward').addClass('button-disabled');
    }

    $('input[name="selectedPv"]').change(function(e) {
        $('.productbox').removeClass('selected');
        $(this).closest('.productbox').addClass('selected');
    });

    $('.togglePackageDetails').click(function(e) {
        e.preventDefault();
        $(this).toggleClass('open').closest('.productboxWrapper').find('.packageDetails').slideToggle();
    });

    if($('#preConfFormPackage').length !== 0) {
        $('.replacePersons').html(householdPersons + ' ' + (householdPersons !== '1' ? translations['person_plural'] : translations['person_singular']));
        $('.replaceKwh').html(yearlyPowerConsumption);
        $('.replaceCentPerKwh').html(pricePerKwh);
        openCloseAccordionInitially();
        resizeIframe();
    }
    if($('#preConfFormInfo').length !== 0) {
        openCloseAccordionInitially();
        resizeIframe();
    }

    setTimeout(function() {
        resizeIframe();
    }, 400);
});


window.onresize = function(){
    openCloseAccordionInitially();
    resizeIframe();
};

/* META FUNCTIONS */
function resizeIframe() {
    window.parent.postMessage(['setIframeHeight', document.querySelectorAll("html")[0].offsetHeight + 1], '*');
}
setInterval(function () {
    resizeIframe()
}, 1000);